// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\Home\ViewModels.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { CoordinationCard, CoordinationCardData, CoordinationCardOptions } from 'data/models/CoordinationCard';
import { HomePageCruiseVisit as _HomePageCruiseVisit, HomePageCruiseVisitData as _HomePageCruiseVisitData, HomePageCruiseVisitOptions as _HomePageCruiseVisitOptions, HomePageInPortVessel as _HomePageInPortVessel, HomePageInPortVesselData as _HomePageInPortVesselData, HomePageInPortVesselOptions as _HomePageInPortVesselOptions, HomePageMovement as _HomePageMovement, HomePageMovementData as _HomePageMovementData, HomePageMovementOptions as _HomePageMovementOptions, HomePagePortMovements as _HomePagePortMovements, HomePagePortMovementsData as _HomePagePortMovementsData, HomePagePortMovementsOptions as _HomePagePortMovementsOptions } from 'data/models/HomePage';
import { ItineraryPoint, ItineraryPointData, ItineraryPointOptions } from 'data/models/ItineraryPoint';
import { Measurement, MeasurementData, MeasurementOptions } from 'data/models/Measurement';

// HomePageDateMovementsData is the class that HomePageDateMovements serializes to/from
export interface HomePageDateMovementsData {
    Date : /* ISO8601 */ string;
	
    Ports : _HomePagePortMovementsData[] | null;
	
}

// HomePageDateMovementsOptions is the class which may be passed to the HomePageDateMovements constructor to define optional initial data values
export interface HomePageDateMovementsOptions {
    Date : /* ISO8601 */ string;
	
    Ports? : _HomePagePortMovementsOptions[] | null;
	
}

export class HomePageDateMovements {
    public Date : DataSignal<TZDate>;
	
    public Ports : SDataArray<_HomePagePortMovements>;
	

    constructor();
    constructor(data : HomePageDateMovementsOptions);
    constructor(data: HomePageDateMovementsOptions | null = null) {
        this.Date = jsonableObservable(S.value<TZDate>(data && data.Date !== undefined ? new TZDate(data.Date) : new TZDate(0), TZDate.eq));
	    
        this.Ports = SArray<_HomePagePortMovements>([]);
	    
    }

    static key(obj : HomePageDateMovements) {
        return obj.Date().toJSON();
    }
    
    static dataKey(obj : HomePageDateMovementsOptions) {
        return new TZDate(obj.Date).toJSON();
    }

    static update(obj : HomePageDateMovements, data : HomePageDateMovementsOptions) {
        S.freeze(() => {
            if (data.Date !== undefined) obj.Date(new TZDate(data.Date));
	        
	        
        });
    }
}

// HomePagePortMovementsData is the class that HomePagePortMovements serializes to/from
export interface HomePagePortMovementsData {
    Date : /* ISO8601 */ string;
    PortId : number;
	
    Movements : _HomePageMovementData[] | null;
	
    PortName : string | null;
}

// HomePagePortMovementsOptions is the class which may be passed to the HomePagePortMovements constructor to define optional initial data values
export interface HomePagePortMovementsOptions {
    Date : /* ISO8601 */ string;
    PortId : number;
	
    Movements? : _HomePageMovementOptions[] | null;
	
    PortName? : string | null;
}

export class HomePagePortMovements {
    public Date : DataSignal<TZDate>;
    public PortId : DataSignal<number>;
	
    public Movements : SDataArray<_HomePageMovement>;
	
    public PortName : DataSignal<string | null>;

    constructor();
    constructor(data : HomePagePortMovementsOptions);
    constructor(data: HomePagePortMovementsOptions | null = null) {
        this.Date = jsonableObservable(S.value<TZDate>(data && data.Date !== undefined ? new TZDate(data.Date) : new TZDate(0), TZDate.eq));
        this.PortId = jsonableObservable(S.value<number>(data && data.PortId !== undefined ? data.PortId : 0));
	    
        this.Movements = SArray<_HomePageMovement>([]);
	    
        this.PortName = jsonableObservable(S.value<string | null>(data && data.PortName !== undefined ? data.PortName : null));
    }

    static key(obj : HomePagePortMovements) {
        return obj.Date().toJSON() + '\u2618' + obj.PortId();
    }
    
    static dataKey(obj : HomePagePortMovementsOptions) {
        return new TZDate(obj.Date).toJSON() + '\u2618' + obj.PortId;
    }

    static update(obj : HomePagePortMovements, data : HomePagePortMovementsOptions) {
        S.freeze(() => {
            if (data.Date !== undefined) obj.Date(new TZDate(data.Date));
            if (data.PortId !== undefined) obj.PortId(data.PortId);
	        
	        
            if (data.PortName !== undefined) obj.PortName(data.PortName);
        });
    }
}

// HomePageMovementData is the class that HomePageMovement serializes to/from
export interface HomePageMovementData {
    FromPointId : number;
	
    FromPoint : ItineraryPointData | null;
    PortCallId : number;
    ToPoint : ItineraryPointData | null;
    ToPointId : number;
    TrafficCoordinationCards : CoordinationCardData[] | null;
	
    CanEdit : boolean;
    CanEditActuals : boolean;
    Type : string | null;
    VesselName : string | null;
}

// HomePageMovementOptions is the class which may be passed to the HomePageMovement constructor to define optional initial data values
export interface HomePageMovementOptions {
    FromPointId : number;
	
    FromPoint? : ItineraryPointOptions | null;
    PortCallId? : number;
    ToPoint? : ItineraryPointOptions | null;
    ToPointId? : number;
    TrafficCoordinationCards? : CoordinationCardOptions[] | null;
	
    CanEdit? : boolean;
    CanEditActuals? : boolean;
    Type? : string | null;
    VesselName? : string | null;
}

export class HomePageMovement {
    public FromPointId : DataSignal<number>;
	
    public FromPoint : DataSignal<ItineraryPoint | null>;
    public PortCallId : DataSignal<number>;
    public ToPoint : DataSignal<ItineraryPoint | null>;
    public ToPointId : DataSignal<number>;
    public TrafficCoordinationCards : SDataArray<CoordinationCard>;
	
    public CanEdit : DataSignal<boolean>;
    public CanEditActuals : DataSignal<boolean>;
    public Type : DataSignal<string | null>;
    public VesselName : DataSignal<string | null>;

    constructor();
    constructor(data : HomePageMovementOptions);
    constructor(data: HomePageMovementOptions | null = null) {
        this.FromPointId = jsonableObservable(S.value<number>(data && data.FromPointId !== undefined ? data.FromPointId : 0));
	    
        this.FromPoint = S.value<ItineraryPoint | null>(null);
        this.PortCallId = jsonableObservable(S.value<number>(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.ToPoint = S.value<ItineraryPoint | null>(null);
        this.ToPointId = jsonableObservable(S.value<number>(data && data.ToPointId !== undefined ? data.ToPointId : 0));
        this.TrafficCoordinationCards = SArray<CoordinationCard>([]);
	    
        this.CanEdit = jsonableObservable(S.value<boolean>(data && data.CanEdit !== undefined ? data.CanEdit : false));
        this.CanEditActuals = jsonableObservable(S.value<boolean>(data && data.CanEditActuals !== undefined ? data.CanEditActuals : false));
        this.Type = jsonableObservable(S.value<string | null>(data && data.Type !== undefined ? data.Type : null));
        this.VesselName = jsonableObservable(S.value<string | null>(data && data.VesselName !== undefined ? data.VesselName : null));
    }

    static key(obj : HomePageMovement) {
        return obj.FromPointId();
    }
    
    static dataKey(obj : HomePageMovementOptions) {
        return obj.FromPointId;
    }

    static update(obj : HomePageMovement, data : HomePageMovementOptions) {
        S.freeze(() => {
            if (data.FromPointId !== undefined) obj.FromPointId(data.FromPointId);
	        
            if (data.PortCallId !== undefined) obj.PortCallId(data.PortCallId);
            if (data.ToPointId !== undefined) obj.ToPointId(data.ToPointId);
	        
            if (data.CanEdit !== undefined) obj.CanEdit(data.CanEdit);
            if (data.CanEditActuals !== undefined) obj.CanEditActuals(data.CanEditActuals);
            if (data.Type !== undefined) obj.Type(data.Type);
            if (data.VesselName !== undefined) obj.VesselName(data.VesselName);
        });
    }
}

// HomePagePortInPortVesselsData is the class that HomePagePortInPortVessels serializes to/from
export interface HomePagePortInPortVesselsData {
	
    InPortVessels : HomePageInPortVesselData[] | null;
	
    PortName : string | null;
}

// HomePagePortInPortVesselsOptions is the class which may be passed to the HomePagePortInPortVessels constructor to define optional initial data values
export interface HomePagePortInPortVesselsOptions {
	
    InPortVessels? : HomePageInPortVesselOptions[] | null;
	
    PortName? : string | null;
}

export class HomePagePortInPortVessels {
	
    public InPortVessels : SDataArray<HomePageInPortVessel>;
	
    public PortName : DataSignal<string | null>;

    constructor();
    constructor(data : HomePagePortInPortVesselsOptions);
    constructor(data: HomePagePortInPortVesselsOptions | null = null) {
	    
        this.InPortVessels = SArray<HomePageInPortVessel>([]);
	    
        this.PortName = jsonableObservable(S.value<string | null>(data && data.PortName !== undefined ? data.PortName : null));
    }

    static key(obj : HomePagePortInPortVessels) {
        return ;
    }
    
    static dataKey(obj : HomePagePortInPortVesselsOptions) {
        return ;
    }

    static update(obj : HomePagePortInPortVessels, data : HomePagePortInPortVesselsOptions) {
        S.freeze(() => {
	        
	        
            if (data.PortName !== undefined) obj.PortName(data.PortName);
        });
    }
}

// HomePageInPortVesselData is the class that HomePageInPortVessel serializes to/from
export interface HomePageInPortVesselData {
	
    PortCallId : number;
	
    BerthName : string | null;
    DepartureDate : /* ISO8601 */ string;
    VesselName : string | null;
}

// HomePageInPortVesselOptions is the class which may be passed to the HomePageInPortVessel constructor to define optional initial data values
export interface HomePageInPortVesselOptions {
	
    PortCallId? : number;
	
    BerthName? : string | null;
    DepartureDate? : /* ISO8601 */ string;
    VesselName? : string | null;
}

export class HomePageInPortVessel {
	
    public PortCallId : DataSignal<number>;
	
    public BerthName : DataSignal<string | null>;
    public DepartureDate : DataSignal<TZDate>;
    public VesselName : DataSignal<string | null>;

    constructor();
    constructor(data : HomePageInPortVesselOptions);
    constructor(data: HomePageInPortVesselOptions | null = null) {
	    
        this.PortCallId = jsonableObservable(S.value<number>(data && data.PortCallId !== undefined ? data.PortCallId : 0));
	    
        this.BerthName = jsonableObservable(S.value<string | null>(data && data.BerthName !== undefined ? data.BerthName : null));
        this.DepartureDate = jsonableObservable(S.value<TZDate>(data && data.DepartureDate !== undefined ? new TZDate(data.DepartureDate) : new TZDate(0), TZDate.eq));
        this.VesselName = jsonableObservable(S.value<string | null>(data && data.VesselName !== undefined ? data.VesselName : null));
    }

    static key(obj : HomePageInPortVessel) {
        return ;
    }
    
    static dataKey(obj : HomePageInPortVesselOptions) {
        return ;
    }

    static update(obj : HomePageInPortVessel, data : HomePageInPortVesselOptions) {
        S.freeze(() => {
	        
            if (data.PortCallId !== undefined) obj.PortCallId(data.PortCallId);
	        
            if (data.BerthName !== undefined) obj.BerthName(data.BerthName);
            if (data.DepartureDate !== undefined) obj.DepartureDate(new TZDate(data.DepartureDate));
            if (data.VesselName !== undefined) obj.VesselName(data.VesselName);
        });
    }
}

// HomePageCruiseScheduleData is the class that HomePageCruiseSchedule serializes to/from
export interface HomePageCruiseScheduleData {
	
    CruiseVisits : HomePageCruiseVisitData[] | null;
    PortId : number;
	
    PortName : string | null;
}

// HomePageCruiseScheduleOptions is the class which may be passed to the HomePageCruiseSchedule constructor to define optional initial data values
export interface HomePageCruiseScheduleOptions {
	
    CruiseVisits? : HomePageCruiseVisitOptions[] | null;
    PortId? : number;
	
    PortName? : string | null;
}

export class HomePageCruiseSchedule {
	
    public CruiseVisits : SDataArray<HomePageCruiseVisit>;
    public PortId : DataSignal<number>;
	
    public PortName : DataSignal<string | null>;

    constructor();
    constructor(data : HomePageCruiseScheduleOptions);
    constructor(data: HomePageCruiseScheduleOptions | null = null) {
	    
        this.CruiseVisits = SArray<HomePageCruiseVisit>([]);
        this.PortId = jsonableObservable(S.value<number>(data && data.PortId !== undefined ? data.PortId : 0));
	    
        this.PortName = jsonableObservable(S.value<string | null>(data && data.PortName !== undefined ? data.PortName : null));
    }

    static key(obj : HomePageCruiseSchedule) {
        return ;
    }
    
    static dataKey(obj : HomePageCruiseScheduleOptions) {
        return ;
    }

    static update(obj : HomePageCruiseSchedule, data : HomePageCruiseScheduleOptions) {
        S.freeze(() => {
	        
            if (data.PortId !== undefined) obj.PortId(data.PortId);
	        
            if (data.PortName !== undefined) obj.PortName(data.PortName);
        });
    }
}

// HomePageCruiseVisitData is the class that HomePageCruiseVisit serializes to/from
export interface HomePageCruiseVisitData {
	
    PortCallId : number;
    ReservationId : number;
	
    Arrival : /* ISO8601 */ string;
    BerthName : string | null;
    Deparature : /* ISO8601 */ string;
    ExpectedPassengerCount : number | null;
    LastPortOfCall : string | null;
    Length : MeasurementData;
    VesselName : string | null;
}

// HomePageCruiseVisitOptions is the class which may be passed to the HomePageCruiseVisit constructor to define optional initial data values
export interface HomePageCruiseVisitOptions {
	
    PortCallId? : number;
    ReservationId? : number;
	
    Arrival? : /* ISO8601 */ string;
    BerthName? : string | null;
    Deparature? : /* ISO8601 */ string;
    ExpectedPassengerCount? : number | null;
    LastPortOfCall? : string | null;
    Length? : MeasurementOptions;
    VesselName? : string | null;
}

export class HomePageCruiseVisit {
	
    public PortCallId : DataSignal<number>;
    public ReservationId : DataSignal<number>;
	
    public Arrival : DataSignal<TZDate>;
    public BerthName : DataSignal<string | null>;
    public Deparature : DataSignal<TZDate>;
    public ExpectedPassengerCount : DataSignal<number | null>;
    public LastPortOfCall : DataSignal<string | null>;
    public Length : Measurement;
    public VesselName : DataSignal<string | null>;

    constructor();
    constructor(data : HomePageCruiseVisitOptions);
    constructor(data: HomePageCruiseVisitOptions | null = null) {
	    
        this.PortCallId = jsonableObservable(S.value<number>(data && data.PortCallId !== undefined ? data.PortCallId : 0));
        this.ReservationId = jsonableObservable(S.value<number>(data && data.ReservationId !== undefined ? data.ReservationId : 0));
	    
        this.Arrival = jsonableObservable(S.value<TZDate>(data && data.Arrival !== undefined ? new TZDate(data.Arrival) : new TZDate(0), TZDate.eq));
        this.BerthName = jsonableObservable(S.value<string | null>(data && data.BerthName !== undefined ? data.BerthName : null));
        this.Deparature = jsonableObservable(S.value<TZDate>(data && data.Deparature !== undefined ? new TZDate(data.Deparature) : new TZDate(0), TZDate.eq));
        this.ExpectedPassengerCount = jsonableObservable(S.value<number | null>(data && data.ExpectedPassengerCount !== undefined ? data.ExpectedPassengerCount : null));
        this.LastPortOfCall = jsonableObservable(S.value<string | null>(data && data.LastPortOfCall !== undefined ? data.LastPortOfCall : null));
        this.Length = data && data.Length !== undefined ? new Measurement(data.Length) : new Measurement();
        this.VesselName = jsonableObservable(S.value<string | null>(data && data.VesselName !== undefined ? data.VesselName : null));
    }

    static key(obj : HomePageCruiseVisit) {
        return ;
    }
    
    static dataKey(obj : HomePageCruiseVisitOptions) {
        return ;
    }

    static update(obj : HomePageCruiseVisit, data : HomePageCruiseVisitOptions) {
        S.freeze(() => {
	        
            if (data.PortCallId !== undefined) obj.PortCallId(data.PortCallId);
            if (data.ReservationId !== undefined) obj.ReservationId(data.ReservationId);
	        
            if (data.Arrival !== undefined) obj.Arrival(new TZDate(data.Arrival));
            if (data.BerthName !== undefined) obj.BerthName(data.BerthName);
            if (data.Deparature !== undefined) obj.Deparature(new TZDate(data.Deparature));
            if (data.ExpectedPassengerCount !== undefined) obj.ExpectedPassengerCount(data.ExpectedPassengerCount);
            if (data.LastPortOfCall !== undefined) obj.LastPortOfCall(data.LastPortOfCall);
            if (data.Length !== undefined) Measurement.update(obj.Length, data.Length);
            if (data.VesselName !== undefined) obj.VesselName(data.VesselName);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/HomePage.ts